import { Container, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { AccountCourseAttendanceDto, CourseService } from "../../../api/psc";
import { PageHeader, Spinner } from "../../../components/exports";
import AttendanceHistoryListItem from "../components/AttendanceHistoryListItem";

export default function CourseAttendanceHistory() {
    const [attendance, setAttendance] = useState<
        AccountCourseAttendanceDto[] | null
    >(null);

    useEffect(() => {
        CourseService.getAttendanceHistory("1").then((r) => {
            setAttendance(r);
        });
    }, []);

    return (
        <Container maxWidth="sm">
            <PageHeader title="تاریخچه دوره ها" />

            {attendance === null && <Spinner />}

            {attendance && (
                <Stack spacing={2}>
                    {attendance.map((a) => {
                        return (
                            <AttendanceHistoryListItem
                                key={a.course.id}
                                item={a}
                            />
                        );
                    })}
                </Stack>
            )}
        </Container>
    );
}
